import { FuseScrollbars } from '@fuse';
import { Paper, Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel, withStyles } from '@material-ui/core';
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import * as AppActions from 'app/store/actions';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import * as Actions from './Store/Actions/TarefaApontamentoActions';

const styles = theme => ({
    root: {
        padding: '5px 4px',
        display: 'flex',
        alignItems: 'center',
        border: '1px solid #d2d2d2',
        marginBottom: "16px"
    },
    lastLine: {
        borderBottom: '0px'
    },
    spanlabel: {
        top: 9,
        left: 10,
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        paddingRight: 5,
        paddingLeft: 5,
        fontSize: 12.5,
        fontFamily: 'Muli,Roboto,"Helvetica",Arial,sans-serif',
        color: theme.palette.text.secondary,
        maxWidth: '70px',
    }
});

const rows = [
    {
        id: 'idtarefaprocessoapontamentooperacao',
        align: 'left',
        disablePadding: false,
        label: 'ID',
        sort: true
    },
    {
        id: 'operacao',
        align: 'left',
        disablePadding: false,
        label: 'Operação',
        sort: true
    },
    {
        id: 'descricao',
        align: 'left',
        disablePadding: false,
        label: 'Descrição',
        sort: true
    },
    {
        id: 'operacaodata',
        align: 'left',
        disablePadding: false,
        label: 'Data',
        sort: true
    },
    {
        id: 'operacaousuario',
        align: 'left',
        disablePadding: false,
        label: 'Usuário',
        sort: true
    }
];

class TarefaApontamentoOperacao extends XAPPComponent {

    getOperacoes = () => {
        var AResponse = [];
        const { TarefaProcessoApontamento } = this.props;

        if (TarefaProcessoApontamento.operacoes !== null) {
            AResponse = TarefaProcessoApontamento.operacoes;
        }

        return AResponse;
    }

    render() {
        const { classes } = this.props;
        var AArray = this.getOperacoes();
        if (AArray.length < 1) {
            return (
                <div />
            )
        }
        else {
            return (
                <div className="w-full flex flex-col">
                    <span className={classes.spanlabel}>{"Operações"}</span>
                    <Paper className={classes.root} elevation={0} rounded={true}>
                        <FuseScrollbars className="flex-grow overflow-x-auto">
                            <Table className="min-w-md" aria-labelledby="tableTitle">
                                <TableHead>
                                    <TableRow className="h-46">
                                        {rows.map(row => {
                                            return (
                                                <TableCell
                                                    key={row.id}
                                                    align={row.align}
                                                    padding={row.disablePadding ? 'none' : 'default'}
                                                >
                                                    <TableSortLabel>
                                                        {row.label}
                                                    </TableSortLabel>
                                                </TableCell>
                                            );
                                        }, this)}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {AArray.map((item) => {
                                        return (
                                            AArray.length ? (
                                                <TableRow
                                                    className="h-48 cursor-pointer"
                                                >
                                                    <TableCell component="td" scope="row">
                                                        {item.idtarefaprocessoapontamentooperacao}
                                                    </TableCell>
                                                    <TableCell component="td" scope="row" padding="none">
                                                        {item.operacao}
                                                    </TableCell>
                                                    <TableCell component="td" scope="row">
                                                        {item.descricao}
                                                    </TableCell>
                                                    <TableCell component="td" scope="row">
                                                        {item.operacaodata}
                                                    </TableCell>
                                                    <TableCell component="td" scope="row">
                                                        {item.operacaousuariodescricao}
                                                    </TableCell>
                                                </TableRow>
                                            ) : (
                                                <TableRow
                                                    className="h-48 cursor-pointer"
                                                >
                                                    <TableCell component="td" scope="row" className={classes.lastLine}>
                                                        {item.idtarefaprocessoapontamentooperacao}
                                                    </TableCell>
                                                    <TableCell component="td" scope="row" padding="none" className={classes.lastLine}>
                                                        {item.operacao}
                                                    </TableCell>
                                                    <TableCell component="td" scope="row" className={classes.lastLine}>
                                                        {item.descricao}
                                                    </TableCell>
                                                    <TableCell component="td" scope="row" className={classes.lastLine}>
                                                        {item.operacaodata}
                                                    </TableCell>
                                                    <TableCell component="td" scope="row" className={classes.lastLine}>
                                                        {item.operacaousuariodescricao}
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </FuseScrollbars>
                    </Paper>
                </div>
            );
        }
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        list: Actions.list,
        remove: Actions.remove,
        showMessage: AppActions.showMessage,
    }, dispatch);
}

function mapStateToProps({ TarefaApontamento }) {
    return {
        TarefaProcessoApontamento: TarefaApontamento,
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(TarefaApontamentoOperacao)));
